// eslint-disable-next-line no-unused-vars
import { Tooltip } from 'bootstrap'

export const tooltip = {

    mounted(el) {
        new Tooltip(el)
    }

}